import { Button, Theme } from '@mui/material';
import {
  CreateInteractionBody,
  UpdateInteractionBody,
} from '@loyalty/shared-common/profile-api-client';
import { Feature } from '@loyalty/shared-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QlfPlaceholder } from '@qualifio/ui-commons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faReceipt } from '@fortawesome/pro-solid-svg-icons/faReceipt';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { InteractionForm } from './InteractionForm';
import { QlfPlaceholderIcon } from '../../../shared/qlf-placeholder-icon/QlfPlaceholderIcon';
import { useFeatures } from '../../../features/FeaturesContext';
import { useInteractionsContext } from '../../InteractionsContext';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  mainIcon: {
    color: '#BBBBBB',
    marginBottom: spacing(1),
  },
}));

export function InteractionDetail() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { features } = useFeatures();
  const { write: interactionWrite } = features[Feature.INTERACTION];
  const { createInteraction, selectedInteraction, addInteraction, updateInteraction } =
    useInteractionsContext();

  const handleSave = async (interaction: CreateInteractionBody | UpdateInteractionBody) => {
    if (selectedInteraction?.isNew) {
      await addInteraction(interaction as CreateInteractionBody);
    } else if (selectedInteraction?.id) {
      await updateInteraction(selectedInteraction.id, interaction as UpdateInteractionBody);
    }
  };

  return !selectedInteraction ? (
    <QlfPlaceholder
      icon={<QlfPlaceholderIcon icon={faReceipt} className={classes.mainIcon} />}
      primaryText={t('interactions.states.empty.title')}
      secondaryText={t('interactions.states.empty.description')}
      actions={
        <Button
          color="primary"
          startIcon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => createInteraction()}
          disabled={!interactionWrite}
          sx={{ marginTop: '20px' }}
        >
          {t('interactions.states.empty.create-action')}
        </Button>
      }
    />
  ) : (
    <InteractionForm
      key={selectedInteraction.id}
      interaction={selectedInteraction}
      onSubmit={handleSave}
    />
  );
}
